import { FaSpinner } from 'react-icons/fa';

export default function ShowPending({ isPending }: { isPending: boolean }) {
  if (!isPending) return null;
  return (
    <div className='w-full h-36 flex justify-center items-center'>
      <FaSpinner className='animate-spin text-[32px] text-gray-500 dark:text-gray-500' />
    </div>
  );
}
